<div class="company-suggestion" data-qa="company-match">
  <div class="grid" data-qa="match-title-grid">
    <div class="col-12" data-qa="match-title-col">
      <span class="registration-title">We think we've found a match.</span>
    </div>
  </div>
  <div class="grid registration-sub-title" data-qa="match-subtitle-grid">
    <div class="col-12" data-qa="match-subtitle-col">
      Your company may already have a profile. Select an existing profile from
      the list below to request to join an existing account or claim a profile.
    </div>
  </div>
  <div class="vendors-container" data-qa="vendor-suggestions">
    <div
      *ngFor="let result of suggestedVendors; let i = index"
      class="vendor-cards"
      data-qa="vendor-card"
    >
      <suggestion-vendor-card
        [vendor]="result"
        [isClaimed]="!!result.isRegistered"
        (toggleCardSelection)="onToggleCardSelection($event)"
      ></suggestion-vendor-card>
    </div>
  </div>
</div>
